module.exports = "/_next/static/images/389239dc033a8f92e52890f83918451c-roxinho-single-xs@3x.jpg";